// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1BuDM","author":"Table_author__3T-90","authorImage":"Table_authorImage__1Q36y","unreadRow":"Table_unreadRow__1DfSW"};